module.exports = __webpack_public_path__ + "img/iphone-mockup-2.b7903a01.png";